import useGetOnlineStatus from '@shared/hooks/useGetOnlineStatus';

const NetworkProvider = () => {
  useGetOnlineStatus();

  return null;
};
export default NetworkProvider;
